<template>
  <payout-form-group v-if="showGroup">
    <div class="form-control-space">
      <payout-destination-currency-conversion-notice
          :source-currency="sourceCurrency"
          :dest-currency="destCurrency"></payout-destination-currency-conversion-notice>
    </div>
  </payout-form-group>
</template>

<script lang="ts">
import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';
import { Account } from '@/models/finance/account';
import PayoutFormGroup from '@/components/forms/payout/PayoutFormGroup.vue';
import PayoutDestinationCurrencyConversionNotice
  from "@/components/forms/payout/PayoutDestinationCurrencyConversionNotice.vue";
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";

@Component({
  name: 'payout-destination-currency-conversion-notice-form-group',
  components: {PayoutDestinationCurrencyConversionNotice, PayoutFormGroup},
})
export default class PayoutDestinationCurrencyConversionNoticeFormGroup extends Vue {
  @Prop({ required: true })
  model: PayoutWebModel

  get showGroup() {
    return Boolean(this.destCurrency && this.sourceCurrency);
  }

  get sourceAccount(): Account | null {
    const accountNumber = this.model.values.fromAccount;
    if (!accountNumber || !this.model?.options || !this.model?.options?.accounts) return null;

    for (const account of this.model?.options?.accounts) {
      if (account.number === accountNumber) return account;
    }

    return null;
  }

  // get destAccount(): Account | null {
  //   const accountNumber = this.model.values.destAccount;
  //   if (!accountNumber)
  //     return null;
  //   for (const account of this.model.options.accounts)
  //   {
  //     if (account.number === accountNumber)
  //       return account;
  //   }
  //
  //   return null;
  // }

  get sourceCurrency() {
    if (!this.sourceAccount) return null;

    return this.sourceAccount.currency;
  }

  get destCurrency() {
    const sourceCurrency = this.sourceAccount?.currency || this.model.getSourceAccount()?.currency || null
    const currency = this.model.getDestCurrency() || [];

    if (sourceCurrency && currency.includes(sourceCurrency))
      return sourceCurrency;

    if (currency.length > 0)
      return currency[0];

    return null;
  }
}
</script>

<style scoped>

</style>
